import { render, staticRenderFns } from "./orderBanner.vue?vue&type=template&id=018ae68a&scoped=true"
import script from "./orderBanner.vue?vue&type=script&lang=js"
export * from "./orderBanner.vue?vue&type=script&lang=js"
import style0 from "./orderBanner.vue?vue&type=style&index=0&id=018ae68a&prod&lang=scss&scoped=true"
import style1 from "./orderBanner.vue?vue&type=style&index=1&id=018ae68a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018ae68a",
  null
  
)

export default component.exports